import {
  hexToRGB,
  TEAL_300,
  TEAL_600,
} from '@wandb/weave/common/css/globals.styles';
import {TargetBlank} from '@wandb/weave/common/util/links';
import {IconLightbulbInfo} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Panel = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const OffsetUp = styled.div`
  position: relative;
  top: -64px;
`;

export const Circle = styled.div`
  border-radius: 50%;
  width: 64px;
  height: 64px;
  background-color: ${hexToRGB(TEAL_300, 0.48)};
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
`;

export const LightBulb = styled(IconLightbulbInfo)`
  width: 36px;
  height: 48px;
  color: ${TEAL_600};
`;

export const Heading = styled.div`
  text-align: center;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 8px;
`;

export const Message = styled.div`
  text-align: center;
  max-width: 600px;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 20px;
`;

export const FollowUpMessage = styled.div`
  text-align: center;
  max-width: 600px;
  font-size: 16px;
  line-height: 25px;
  margin-bottom: 20px;
`;

export const Link = styled(TargetBlank)`
  margin-left: 4px;
`;
Link.displayName = 'S.Link';
